<template>
  <element>
    <nav-breadcrumb :menu="[{label: '融资放款'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <form-build
          :form-data="payDetail"
          :form-rules="payRules"
          :form-columns="payColumns"
          class="formTable"
        />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="onSubmit()">确认提交</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-col>
    </el-row>
  </element>
</template>

<script>
    export default {
        name: "PaymentFinancingView",
        data(){
          return {
            payColumns:[
              {
                label: '贷款编号',
                field: 'fi__transactionNo',
                component: 'el-input',
                type: 'text',
              },
            ],
            payDetail:{},
            payRules:{},
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/PaymentFinancing.vue